import { State } from '../../types';

export const florida: State = {
  name: 'Florida',
  abbreviation: 'FL',
  terms: [
    {
      word: 'Apalachicola',
      phonetic: 'Ap-uh-LACH-uh-koh-luh',
      // audioUrl: '/audio/miami.mp3',
      description: 'A historic fishing town in the Panhandle known for its oysters.'
    },
    {
      word: 'Bokeelia',
      phonetic: 'Boh-KEE-lee-uh',
      // audioUrl: '/audio/miami.mp3',
      description: 'A small community on Pine Island known for its fishing and natural beauty.'
    },
    {
      word: 'Dunedin',
      phonetic: 'DUH-nee-den.',
      // audioUrl: '/audio/miami.mp3',
      description: 'A city in Pinellas County.'
    },
    {
      word: 'Immokalee',
      phonetic: 'ih-MAH-kuh-lee',
      // audioUrl: '/audio/immokalee.mp3',
      description: 'A town in Collier County, pronounced "ih-MAH-kuh-lee," not "im-oh-KAH-lee."'
    },
    {
      word: 'Kissimmee',
      phonetic: 'kuh-SIM-ee',
      // audioUrl: '/audio/kissimmee.mp3',
      description: 'A city in Osceola County, pronounced "kuh-SIM-ee," not "kiss-uh-MEE."'
    },
    {
      word: 'Miami',
      phonetic: 'my-AM-ee',
      // audioUrl: '/audio/miami.mp3',
      description: 'Major city in southern Florida'
    },
    {
      word: 'Micanopy',
      phonetic: 'mik-uh-NO-pee',
      // audioUrl: '/audio/micanopy.mp3',
      description: 'A town in Alachua County, pronounced "mik-uh-NO-pee," not "mike-uh-no-pee."'
    },
    {
      word: 'Thonotosassa',
      phonetic: 'thoh-noh-tuh-SASS-uh',
      // audioUrl: '/audio/thonotosassa.mp3',
      description: 'A community in Hillsborough County, pronounced "thoh-noh-tuh-SASS-uh," not "thon-oh-toe-sah-sah."'
    },
    {
      word: 'Wewahitchka',
      phonetic: 'wee-wah-HITCH-kuh',
      // audioUrl: '/audio/wewahitchka.mp3',
      description: 'A city in Gulf County, pronounced "wee-wah-HITCH-kuh," not "wee-wah-hitch-kah."'
    },
    {
      word: 'Withlacoochee',
      phonetic: 'with-lah-KOO-chee',
      // audioUrl: '/audio/withlacoochee.mp3',
      description: 'A river in central Florida, pronounced "with-lah-KOO-chee," not "with-lah-coo-chee."'
    }
  ]
};